import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MyTasksPageComponent } from "./myTasks/my-tasks-page/my-tasks-page.component";
import { PageGeneralErrorComponent } from "./shell/page-general-error/page-general-error.component";
import { PageNotFoundComponent } from "./shell/page-not-found";
import { RootRedirectComponent } from "./shell/root-redirect";
import { MsalGuard } from "@azure/msal-angular";

// do NOT redirect - all query-params get lost on redirect
const routes: Routes = [
  { path: "", pathMatch: "full", component: RootRedirectComponent, canActivate: [MsalGuard] },
  { path: "tasks", pathMatch: "full", component: MyTasksPageComponent, canActivate: [MsalGuard] },
  { path: "error", component: PageGeneralErrorComponent },
  { path: "**", component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
